import {
	observer
} from 'mobx-react';
import {
	WeaOrgTree,
} from 'ecCom';

@observer
export default class OrgTree extends React.Component {
	constructor(props) {
		super(props);
		this.tree = null;
		this.setRef = element => {
			this.tree = element;
		}
	}

	componentDidMount() {
		this.init()
	}

	componentDidUpdate(prevProps, prevState) {
		this.init()
	}

	init = () => {
		if (this.tree) this.tree.reset(() => this.tree.fetchData());
	}

	render() {
		const {
			store
		} = this.props, {
			triggerRefresh,
			orgTreeProps,
			handleOrgTreeNodeClick,
		} = store;

		return (
			<div style={{height: '100%'}}>
		        <WeaOrgTree ecId={`${this && this.props && this.props.ecId || ''}_WeaOrgTree@0bel37`} 
		        	{...orgTreeProps}
		        	treeNodeClick={handleOrgTreeNodeClick}
		            ref={this.setRef}
		        />
        	</div>
		)
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/public/valhalla/components/OrgTree.js